"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _xLicensePro = require("@ori-ui/mui-bundle/x-license-pro");
const applyLicense = () => _xLicensePro.LicenseInfo.setLicenseKey('c8cd1383dc4459ba9cdef25e543dbaddT1JERVI6NjkxMzYsRVhQSVJZPTE3MTkxNDgwMDMzMzksS0VZVkVSU0lPTj0x');
var _default = exports.default = applyLicense;
